export default {
  publishTitle: 'Publicar contenido',
  editKeywordsTitle: 'Editar palabras clave',
  keywordsLabel: 'Palabras clave',
  keywordsPlaceholder: 'Añade hasta {keywordsAmount} palabras clave para ayudar a las personas a descubrir tu contenido',
  cancel: 'Cancelar',
  publish: 'Publicar',
  save: 'Guardar',
  success: '¡Has publicado tu contenido con éxito!',
  edited: '¡Has editado las palabras con éxito!',
  error: 'Ha ocurrido un error al publicar el contenido',
  language: 'Idioma',
  emptyLanguageOption: 'Todos los idiomas',
  unpublish: 'Despublicar',
  unpublishSuccess: '¡Has despublicado tu contenido con éxito!',
  completePercentage: '{percentage}% completo',
  readyToPublish: '¡Listo para publicar!',
  completeToPublish: 'Completar para publicar'
}

export const en = {
  publishTitle: 'Post content',
  editKeywordsTitle: 'Edit keywords',
  keywordsLabel: 'Keywords',
  keywordsPlaceholder: 'Add up to 10 keywords to help people discover your content',
  cancel: 'Cancel',
  publish: 'Post',
  save: 'Save',
  success: 'You have successfully posted your content!',
  edited: 'You have successfully edited the words!',
  error: 'An error occurred while posting the content',
  language: 'Language',
  emptyLanguageOption: 'All languages',
  unpublish: 'Unpost',
  unpublishSuccess: 'You have successfully unpublished your content!',
  completePercentage: '{percentage}% complete',
  readyToPublish: 'Ready to publish!',
  completeToPublish: 'Complete to publish'
}

export const ca = {
  publishTitle: 'Publicar contingut',
  editKeywordsTitle: 'Editar paraules clau',
  keywordsLabel: 'Paraules clau',
  keywordsPlaceholder: 'Afegeix fins a 10 paraules clau per ajudar les persones a descobrir el contingut',
  cancel: 'Cancel·lar',
  publish: 'Publicar',
  save: 'Desar',
  success: 'Has publicat el teu contingut amb èxit!',
  edited: 'Has editat les paraules amb èxit!',
  error: 'Ha ocorregut un error en publicar el contingut',
  language: 'Idioma',
  emptyLanguageOption: 'Tots els idiomes',
  unpublish: 'Despublicar',
  unpublishSuccess: 'Has despublicat el teu contingut amb èxit!',
  completePercentage: '{percentage}% complet',
  readyToPublish: 'Llest per publicar!',
  completeToPublish: 'Completar per publicar'
}
